// Bedrock global scripts live here.

// BUG-63175: Hide the marketing opt-in checkbox from shopify-account.
// The checkbox lives 3 shadow roots deep so CSS ::part() can't reach it;
// inject a <style> directly into the innermost shadow root instead.
// Observer is scoped to each shopify-account element and disconnected once
// the style is injected, so there is no ongoing per-mutation overhead.
(function () {
  if (!window.__bundabergSettings?.hideAccountMarketingCheckbox) return;

  const injectHideStyle = (shadowRoot) => {
    if (shadowRoot.querySelector('#bundaberg-no-marketing')) return;
    const s = document.createElement('style');
    s.id = 'bundaberg-no-marketing';
    s.textContent = '.login-form__marketing-consent{display:none!important}';
    shadowRoot.prepend(s);
  };

  const findAndHide = (root) => {
    if (!root) return false;
    for (const el of root.querySelectorAll('*')) {
      if (!el.shadowRoot) continue;
      if (el.shadowRoot.querySelector('.login-form__marketing-consent')) {
        injectHideStyle(el.shadowRoot);
        return true;
      }
      if (findAndHide(el.shadowRoot)) return true;
    }
    return false;
  };

  const watchAccount = (accountEl) => {
    if (!accountEl.shadowRoot) return;
    if (findAndHide(accountEl.shadowRoot)) return;
    const observer = new MutationObserver(() => {
      if (findAndHide(accountEl.shadowRoot)) observer.disconnect();
    });
    observer.observe(accountEl.shadowRoot, { childList: true, subtree: true });
  };

  customElements.whenDefined('shopify-account').then(() => {
    for (const el of document.querySelectorAll('shopify-account')) {
      watchAccount(el);
    }
  });
})();
